module.exports = __webpack_public_path__ + "img/partner03.42dd973b.png";